export default __webpack_public_path__ + "static/media/pub2-flame.972fdbe6.png";